import { useSelector } from "react-redux";
import { RootState } from "store/store";

export function useSelectedRunway() {
  return useSelector((st: RootState) => st.localState.selectedRunway);
}
